import React, { useState } from "react";
import { Link } from "react-router-dom";
import bgheader2png from "../../../assets/images/bg-header-2.png";
import StoreCard from "../../../components/StoreCard";
import product1png from "../../../assets/images/product-1.png";

function Store(props) {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(true);
  };

  const cardsData = [
    {
      id: 1,
      text: "Quantial – Moving Upon Signs Moveth Lesser",
      demo: "Live Demo",
      buy: " Buy Now",
      price: "$49",
      image: product1png,
    },
    {
      id: 2,
      text: "Sensific – Saying Beast Lesser for in Fruitful",
      demo: "Live Demo",
      buy: " Buy Now",
      price: "$59",
      image: product1png,
    },
    {
      id: 3,
      text: "Minist – Subdue Above for Signs Dry is Have Great",
      demo: "Live Demo",
      buy: " Buy Now",
      price: "$69",
      image: product1png,
    },
    {
      id: 4,
      text: "Desty – She'd Under Light Over Multiply Stars Winged",
      demo: "Live Demo",
      buy: " Buy Now",
      price: "$79",
      image: product1png,
    },
    {
      id: 5,
      text: "Silies – Grass Living Fly Subdue After Fruitful",
      demo: "Live Demo",
      buy: " Buy Now",
      price: "$43",
      image: product1png,
    },
    {
      id: 6,
      text: "Interra – Evening Were Set Beginning Image That One",
      demo: "Live Demo",
      buy: " Buy Now",
      price: "$98",
      image: product1png,
    },
    {
      id: 7,
      text: "Explora – Open Winged Lights Spirit Very Subdue",
      demo: "Live Demo",
      buy: " Buy Now",
      price: "$42",
      image: product1png,
    },
    {
      id: 8,
      text: "Thoute – Yielding Land Fill Gathering Midst Second",
      demo: "Live Demo",
      buy: " Buy Now",
      price: "$46",
      image: product1png,
    },
    {
      id: 9,
      text: "Accountry – Saying Gathering Image Above Dominion",
      demo: "Live Demo",
      buy: " Buy Now",
      price: "$54",
      image: product1png,
    },
    {
      id: 10,
      text: "Mained – Third Lights Greater Were Morning",
      demo: "Live Demo",
      buy: " Buy Now",
      price: "$33",
      image: product1png,
    },
    {
      id: 11,
      text: "Treate – Blessed Which Give May Make Life Sea Days",
      demo: "Live Demo",
      buy: " Buy Now",
      price: "$42",
      image: product1png,
    },
    {
      id: 12,
      text: "Priety – Living Given Night a in Itself Lesser Fowl",
      demo: "Live Demo",
      buy: " Buy Now",
      price: "$54",
      image: product1png,
    },
  ];
  return (
    <>
      <div className="dx-main">
        <header className="dx-header dx-box-1">
          <div className="container">
            <div className="bg-image bg-image-parallax">
              <img src={bgheader2png} className="jarallax-img" alt="" />
              <div style={{ backgroundColor: "rgba(27, 27, 27, 0.8)" }}></div>
            </div>
            <div className="row justify-content-center">
              <div className="col-xl-7">
                <h1 className="h2 mb-30 text-white text-center">
                  Digital Products
                </h1>
                <form action="#" className="dx-form dx-form-group-inputs">
                  <input
                    type="text"
                    name=""
                    value=""
                    className="form-control"
                    placeholder="Keyword search..."
                  />
                  <button className="dx-btn dx-btn-lg">Search</button>
                </form>
              </div>
            </div>
          </div>
        </header>
        <div className="dx-isotope-container">
          <div className="dx-box bg-white">
            <div className="container">
              <ul className="dx-links dx-isotope-filter text-center">
                <li className="active" data-filter="*">
                  All Items
                </li>
                <li data-filter=".theme">Themes</li>
                <li data-filter=".template">Templates</li>
                <li data-filter=".plugin">Plugins</li>
              </ul>
            </div>
          </div>
          <div className="dx-separator"></div>
          <div className="dx-box-5 pb-100 bg-grey-6">
            <div className="container">
              <div className="row vertical-gap dx-isotope-grid">
                {cardsData.map((card) => {
                  return (
                    <>
                      <StoreCard key={card.id} text={card.text} card={card} />
                    </>
                  );
                })}
              </div>
              <div className="text-center mt-70">
                {!show ? (
                  <Link
                    className="dx-btn dx-btn-grey dx-btn-lg dx-btn-load"
                    data-btn-loaded="all products shown"
                    onClick={handleShow}
                  >
                    Load More
                  </Link>
                ) : (
                  <p>All products are shown</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Store;
